module.exports = __webpack_public_path__ + "static/media/home-girl.3c9bbc27.png";